import { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import '../Dashboard/style.css';
import './workflow.css';
import MainLayout from './MainLayout/MainLayout';

class Workflow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAssignmentComplete: this.props.isAssignmentComplete
        }
    }

    render() {
        return (
            <div className={classNames('workflow_main_container_new', this.props.layoutType)}>
                <MainLayout layoutType={this.props.layoutType} />
            </div>
        )
    }
}

Workflow.propTypes = {
    layoutType: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    dashboardTab: PropTypes.string.isRequired
}

const mapStateToProps = (state) => {
    return {
        layoutType: state.layout.layoutType,
        lang: state.layout.lang,
        dashboardTab: state.layout.dashboardTab,
        isAssignmentComplete: state.workflow.case_state?.taxYears[0]?.assigned_tax_pro?.name ? true : false
    }
}


export default connect(mapStateToProps)(Workflow)
